import {
  allDevicesMapSelector,
  devicesMapSelector,
} from '../models/selectors/device_selectors';
import { useRecoilState, useRecoilValue } from 'recoil';
import dayjs from 'dayjs';
import {
  selectedDevicesKeysAtom,
  downloadDeviceDataModeAtom,
} from '../models/atoms/device_atoms';

export function useDownloadDeviceData() {
  // device_id-session_id
  // use 'current' for current session
  const [selectedDeviceKeys, setSelectedDeviceKeys] = useRecoilState(
    selectedDevicesKeysAtom,
  );
  const devicesMap = useRecoilValue(devicesMapSelector);
  const allDevicesMap = useRecoilValue(allDevicesMapSelector);
  const [mode, setMode] = useRecoilState(downloadDeviceDataModeAtom);

  const minStartDate = dayjs
    .unix(
      Math.min(
        ...selectedDeviceKeys.map(
          key => allDevicesMap.get(key)?.first_data ?? dayjs().unix(),
        ),
      ),
    )
    .startOf('day')
    .toDate();

  const maxEndDate = dayjs
    .unix(
      Math.max(
        ...selectedDeviceKeys.map(
          key => allDevicesMap.get(key)?.last_data ?? 0,
        ),
      ),
    )
    .endOf('day')
    .toDate();

  function changeMode(newMode: 'live' | 'all' | 'archived') {
    setMode(newMode);
    if (newMode === 'live') {
      // Filter out archived devices
      setSelectedDeviceKeys(prev => prev.filter(key => devicesMap.has(key)));
    } else if (newMode === 'archived') {
      // Filter out live devices
      setSelectedDeviceKeys(prev => prev.filter(key => !devicesMap.has(key)));
    }
  }

  return {
    selectedDeviceKeys,
    setSelectedDeviceKeys,
    mode,
    changeMode,
    minStartDate,
    maxEndDate,
  };
}
